(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["social-proof-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    function randInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function getStored(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function setStored(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

    function hydrate(badge) {
      var product = badge.getAttribute('data-product') || '0';
      var ranges = {
        count: [parseInt(badge.dataset.countMin, 10), parseInt(badge.dataset.countMax, 10)],
        days:  [parseInt(badge.dataset.daysMin, 10),  parseInt(badge.dataset.daysMax, 10)]
      };
      badge.querySelectorAll('.sp-badge__num').forEach(function (el) {
        var key = el.getAttribute('data-sp-key');
        var r = ranges[key];
        if (!r || isNaN(r[0]) || isNaN(r[1])) return;
        // range in the key => editing range regenerates the number
        var storeKey = 'spbadge:' + product + ':' + key + ':' + r[0] + '-' + r[1];
        var val = getStored(storeKey);
        if (val === null) {
          val = String(randInt(r[0], r[1]));
          setStored(storeKey, val);
        }
        el.textContent = val;
      });
    }

    function init() {
      document.querySelectorAll('[data-sp-badge]').forEach(hydrate);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);

    // Theme editor support
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
